import React, {useContext} from 'react';
import {GlobalContext} from '../../../utilities/GlobalContext';

function Styles() {
	//#region Params
	let isMobile = useContext(GlobalContext).isMobile;
	let size = useContext(GlobalContext).size;
	//#endregion

	//#region Style vars
	let questionareTextFontSize = '1rem';
	//#endregion

	//#region seting vars based off params
	if (size === 'xl') {
		questionareTextFontSize = '1.25rem';
	}
	//#endregion

	return {
		secondQuestionareContainer: () => {
			return {
				width: '100%',
			};
		},
		markBorder: () => {
			return {
				border: '5px solid black',
			};
		},
		rowContainer: () => {
			return {
				marginTop: '1rem',
			};
		},
		hemisphere: () => {
			return {
				display: 'flex',
			};
		},
		button: (settings = {}) => {
			let lean = settings.lean;

			let style = {
				height: '2.5rem',
				border: 0,
				borderRadius: '10px',
				width: '8rem',
				color: 'white',
				backgroundColor: '#262626',
				display: 'flex',
				padding: 0,
			};

			if (lean) {
				if (lean === 'left') {
					style.marginRight = 'auto';
					style.marginLeft = 0;
				} else if (lean === 'right') {
					style.marginLeft = 'auto';
					style.marginRight = 0;
				} else if (lean === 'center') {
					style.marginLeft = 'auto';
					style.marginRight = 'auto';
				}
			}

			return style;
		},
		questionareText: (settings = {}) => {
			let textAlign = settings.textAlign || 'center';

			return {
				textAlign: textAlign,
				fontSize: questionareTextFontSize,
			};
		},
		landingTitle: () => {
			return {
				textAlign: 'center',
			};
		},
		buttonText: () => {
			return {
				width: '100%',
				margin: 'auto',
				textAlign: 'center',
			};
		},
		fullNameContainer: () => {
			return {
				width: '100%',
				margin: 0,
				marginTop: '1rem',
			};
		},
		inputCol: (settings = {}) => {
			let style = {
				display: 'flex',
				flexDirection: 'column',
				padding: 0,
			};

			if (settings.half === 'left' && !isMobile) {
				style.paddingLeft = 0;
				style.paddingRight = '1rem';
			} else if (settings.half === 'right' && !isMobile && size !== 'sm') {
				style.paddingRight = 0;
				style.paddingLeft = '1rem';
			}

			return style;
		},
		input: (settings = {}) => {
			let style = {
				height: '2.5rem',
				marginTop: '1rem',
			};

			return style;
		},
		nextButton: () => {
			return {
				marginTop: '1rem',
			};
		},
		nextNameButton: () => {
			return {
				margin: '1rem 0rem 0rem 0rem',
			};
		},
		ageInputContainer: () => {
			return {
				display: 'flex',
				flexDirection: 'column',
			};
		},
		ageInput: () => {
			return {
				marginTop: '1rem',
			};
		},
	};
}

export default Styles;
